'use client'
import { PageTitle } from 'pageSections/PageTitle'

function PoliciesHero({ content }) {
  return <PageTitle content={content} />
}

export { PoliciesHero }
export default PoliciesHero
